import type { ReportPayload } from "@ark-snitch/shared";
import { snapshotConsoleBuffer } from "./buffers/console";
import { snapshotNetworkBuffer } from "./buffers/network";

export const buildReportPayload = (
  custom?: Record<string, unknown>,
): ReportPayload => {
  const navTiming = performance.getEntriesByType?.(
    "navigation",
  )[0] as PerformanceNavigationTiming | undefined;

  return {
    user_agent: navigator.userAgent,
    current_url: location.href,
    referrer: document.referrer || undefined,
    window_size: {
      width: window.innerWidth,
      height: window.innerHeight,
      dpr: window.devicePixelRatio || 1,
    },
    viewport_size: {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    },
    console_logs: snapshotConsoleBuffer(),
    network_requests: snapshotNetworkBuffer(),
    performance: navTiming
      ? {
          nav_type: navTiming.type,
          ttfb: Math.round(navTiming.responseStart - navTiming.requestStart),
          dom_content_loaded: Math.round(
            navTiming.domContentLoadedEventEnd - navTiming.startTime,
          ),
          load: Math.round(navTiming.loadEventEnd - navTiming.startTime),
        }
      : undefined,
    custom,
  };
};
